import { UntypedFormArray, UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import {
  Component,
  OnInit,
  ViewChild,
  Input,
  OnChanges,
  SimpleChanges,
  Output,
  EventEmitter,
  AfterViewInit,
  ChangeDetectorRef,
} from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort, MatSortHeader } from '@angular/material/sort';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import {
  ColumnsConfig,
  ColumnsConfigMap,
  PaidUnpaidChecklist,
} from '@uw/core/models/paid-unpaid-checklist.models';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { PaginationOptions } from '@uw/core/models/filter.model';
import { AuthService } from '@uw/core/services/auth.service';
import { Roles } from '@uw/core/enums/role.enum';
import { MatDatepickerInput, MatDatepicker } from '@angular/material/datepicker';
import { MatCheckbox } from '@angular/material/checkbox';
import { CurrencyPipe, DatePipe } from '@angular/common';

@Component({
    selector: 'uw-paid-unpaid-transaction-list',
    templateUrl: './paid-unpaid-transaction-list.component.html',
    styleUrls: ['./paid-unpaid-transaction-list.component.scss'],
    imports: [ReactiveFormsModule, MatTable, MatSort, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatSortHeader, MatCellDef, MatCell, MatDatepickerInput, MatDatepicker, MatCheckbox, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatPaginator, CurrencyPipe, DatePipe, TranslateModule]
})
export class PaidUnpaidTransactionListComponent
  implements OnInit, OnChanges, AfterViewInit
{
  formTableDataSource!: MatTableDataSource<any>;

  @ViewChild(MatPaginator)
  paginator!: MatPaginator;

  @Input()
  paginationOption!: PaginationOptions;

  @Input()
  donationFormGroup!: UntypedFormGroup;

  @Output()
  page = new EventEmitter();

  readonly currentLanguage = this.translateService.currentLang;

  selection = new SelectionModel<PaidUnpaidChecklist>(true, []);

  receivedColumnSelection = new SelectionModel<PaidUnpaidChecklist>(true, []);

  checkboxSelectionDataSource!: PaidUnpaidChecklist[];
  isWorkspaceAdmin = false;

  
  // selectedDataSource!: PaidUnpaidChecklist[];

  @Input()
  columnsConfig!: ColumnsConfig;

  columnsConfigMap!: ColumnsConfigMap;

  @ViewChild(MatSort)
  sort!: MatSort;

  constructor(
    private translateService: TranslateService,
    public changeDetectorRef: ChangeDetectorRef,
    private authService: AuthService,
  ) {}

  ngOnInit(): void {
    let user = this.authService.getUser();
        if (user) {
          if (user.roleCode == Roles.WorkspaceAdministrator) {
            this.isWorkspaceAdmin = true;
          }
        }
  }

  get donations() {
    return this.donationFormGroup?.controls['donations'] as UntypedFormArray;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes &&
      changes.columnsConfig &&
      changes.columnsConfig.currentValue
    ) {
      this.columnsConfigMap = this.columnsConfig.columnsConfigMap;
    }

    if (changes && changes.donationFormGroup && changes.donationFormGroup.currentValue) {
      this.formTableDataSource = new MatTableDataSource(
        this.donations.controls
      );
      this.formTableDataSource.paginator = this.paginator;
      this.formTableDataSource.sort = this.sort;
      this.selection.clear();
      this.receivedColumnSelection.clear();

      // this.checkboxSelectionDataSource = [...this.dataSource.data.filter(d => d.paid != 'unpaid and uploaded')];

      this.checkboxSelectionDataSource = [...this.donations.value];

      // this.checkboxSelectionDataSource = [...this.dataSource.data.filter(d => d.paid)];
      this.selection.select(
        ...this.checkboxSelectionDataSource.filter((d) => d.paid)
      );

      this.receivedColumnSelection.select(
        ...this.checkboxSelectionDataSource.filter(d => d.received)
      );

      // Disable paid form controls for workspace admins after form setup
      this.disablePaidControlsIfWorkspaceAdmin();
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (this.paginator && this.paginationOption) {
        this.paginator.pageIndex = this.paginationOption.page
          ? this.paginationOption.page
          : 0;
        this.paginator.pageSize = this.paginationOption.limit
          ? this.paginationOption.limit
          : 10;

        if (this.donationFormGroup) {
          this.formTableDataSource = new MatTableDataSource(
            this.donations.controls
          );
          this.formTableDataSource.paginator = this.paginator;
          this.formTableDataSource.sort = this.sort;
          this.selection.clear();
          this.receivedColumnSelection.clear();
          // this.checkboxSelectionDataSource = [...this.dataSource.data.filter(d => d.paid != 'unpaid and uploaded')];
          this.checkboxSelectionDataSource = [...this.donations.value];
          this.selection.select(
            ...this.checkboxSelectionDataSource.filter((d) => d.paid)
          );

          this.receivedColumnSelection.select(
            ...this.checkboxSelectionDataSource.filter(d => d.received)
          );

          // Disable paid form controls for workspace admins after view init
          this.disablePaidControlsIfWorkspaceAdmin();
        }
      }
    });
  }

  onSortChange(sort: any) {
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected(numSelected: number) {    
    const numRows = this.checkboxSelectionDataSource.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  toggleAllRows(toggleField: string, numSelected: number) {    

    if (this.isAllSelected(numSelected)) {
      let donations = this.donations.value;

      donations.forEach((_d: any, index: number) => {
        this.donations.at(index).get(toggleField)?.setValue(false);
      });

      if (toggleField == 'paid') {
        this.selection.clear();
      }

      if (toggleField == 'received') {
        this.receivedColumnSelection.clear();
      }
      
      return;
    }

    if (toggleField == 'paid') {
      this.selection.select(...this.checkboxSelectionDataSource);
    }
    
    if (toggleField == 'received') {
      this.receivedColumnSelection.select(...this.checkboxSelectionDataSource);
    }    

    let donations = this.donations.value;

    donations.forEach((_d: any, index: number) => {
      this.donations.at(index).get(toggleField)?.setValue(true);
    });
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(selection: SelectionModel<PaidUnpaidChecklist>, row?: PaidUnpaidChecklist): string {

    const numSelected = selection.selected.length;

    if (!row) {
      return `${this.isAllSelected(numSelected) ? 'deselect' : 'select'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${
      row.donorName
    }`;
  }

  onPageChange(event: PageEvent) {}

  /**
   * Disables paid form controls for workspace administrators
   */
  private disablePaidControlsIfWorkspaceAdmin(): void {
    if (this.isWorkspaceAdmin && this.donations) {
      this.donations.controls.forEach((control: any) => {
        const paidControl = control.get('paid');
        if (paidControl) {
          paidControl.disable();
        }
      });
    }
  }
}
